import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  AccountsConfigurationKeys,
  AccountsConfigurations,
  ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES,
  ACCOUNTS_FEATURE_NAME,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { selectActiveBasketAccounts } from '@epicuro-next/state/basket-state';
import { isAddressDeleted } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

@Component({
  selector: 'epc-menu-active-accounts',
  templateUrl: './menu-active-accounts.component.html',
  styleUrls: ['./menu-active-accounts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MenuActiveAccountsComponent {
  @Output()
  public navigate = new EventEmitter();

  public maxShowedAccounts = 3;

  public isAccountsClickable$ = this.store.pipe(
    select(
      selectConfigurationValueFrom<
        AccountsConfigurationKeys.IsAccountsInMenuClickable,
        AccountsConfigurations
      >(
        ACCOUNTS_FEATURE_NAME,
        AccountsConfigurationKeys.IsAccountsInMenuClickable,
        ACCOUNTS_CONFIGURATIONS_DEFAULT_VALUES[
          AccountsConfigurationKeys.IsAccountsInMenuClickable
        ],
      ),
    ),
  );

  public accounts$ = this.store.pipe(select(selectActiveBasketAccounts)).pipe(
    map((accounts) =>
      accounts.map((account) => ({
        ...account,
        shipToAddresses: account.shipToAddresses.filter(
          (address) => address.hasDeliveryItems && !isAddressDeleted(address),
        ),
      })),
    ),
  );

  constructor(private store: Store) {}
}
